import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async'
import { BrowserRouter } from 'react-router-dom'
import Site from './Site';

import logger from '@scrippsproduct/console-logger';
logger.setNamespace('scrippssports.com');

const ENV = process.env.REACT_APP_ENV;
if (ENV) {
    logger.setShouldLog(ENV !== 'production');
}

createRoot(document.getElementById('root')).render(
    <>
        <StrictMode>
            <HelmetProvider>
                <BrowserRouter>
                    <Site />
                </BrowserRouter>
            </HelmetProvider>
        </StrictMode>
    </>
);
